<div *ngFor="let s of sizes" #sizeDetectorDiv id="{{ s.id }}" class="{{ s.css + ' ' + (prefix + s.id) }} h-0">{{ s.name }}</div>
